'use client';

import React, { createContext, useContext } from 'react';
import { IconProviderConfig } from './types';
import { defaultIconConfig } from './iconConfig';

interface IconProviderContextValue {
  config: IconProviderConfig;
}

const IconProviderContext = createContext<IconProviderContextValue | undefined>(
  undefined,
);

export function useIconProvider(): IconProviderContextValue {
  const context = useContext(IconProviderContext);
  if (!context) {
    throw new Error('useIconProvider must be used within an IconProvider');
  }
  return context;
}

interface IconProviderProps {
  children: React.ReactNode;
  config?: Partial<IconProviderConfig>;
}

export function IconProvider({ children, config = {} }: IconProviderProps) {
  const mergedConfig: IconProviderConfig = {
    ...defaultIconConfig,
    ...config,
    sizeMap: { ...defaultIconConfig.sizeMap, ...config.sizeMap },
    colorMap: { ...defaultIconConfig.colorMap, ...config.colorMap },
  };

  const value: IconProviderContextValue = {
    config: mergedConfig,
  };

  return (
    <IconProviderContext.Provider value={value}>
      {children}
    </IconProviderContext.Provider>
  );
}
